import styled from 'styled-components';
import theme from 'styles/theme';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.colors.white};
  border-radius: 8px 8px 0 0;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    display: none;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  .h-38 {
    height: 38px !important;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 1;

  > div:first-child {
    max-width: 250px;
    width: 100%;
    margin: 0;
    display: flex;
    align-items: center;
  }

  input {
    height: 38px;
    border-radius: 10px;
    margin: 0;
  }

  label {
    margin-bottom: 0 !important;
  }

  @media (max-width: 768px) {
    > div:first-child {
      max-width: 180px;
    }
  }
`;
